import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter\">\n<rect x=\"0.5\" y=\"0.5\" width=\"31\" height=\"31\" rx=\"2.5\" stroke=\"#D9D9D9\" />\n<path d=\"M8.1416 8.5H23.8581L18.0832 16.6812V23.5H13.9165V16.6812L8.1416 8.5ZM11.3581 10.1667L15.5832 16.1522V21.8333H16.4165V16.1522L20.6416 10.1667H11.3581Z\" fill=\"#232323\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol